<div id="app-wrapper" class="h-screen flex flex-col">
  <!-- Topbar -->
  <header id="main-header">
    <div>
      <a
        [routerLink]="'/dashboard'"
        class="flex items-center gap-3 no-underline rounded focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
      >
        <p-avatar styleClass="bg-primary text-white" shape="circle" size="normal">
          <i class="pi pi-microchip-ai"></i>
        </p-avatar>
        <span class="text-xl font-semibold">{{ brandName() }}</span>
      </a>
    </div>
    <div class="flex-1 mx-4">
      <core-search-omni-search></core-search-omni-search>
    </div>
    <div class="flex items-center gap-4">
      {{ userDisplayName() }}
      <button
        type="button"
        class="p-0 border-0 bg-transparent text-inherit cursor-pointer focus-visible:ring-2 focus-visible:ring-white rounded"
        aria-label="Settings"
        (click)="toggleSettingsMenu($event)"
      >
        <i class="pi pi-cog text-lg"></i>
      </button>
      <!-- <button
        type="button"
        class="p-0 m-0 border-0 bg-transparent text-inherit cursor-pointer focus-visible:ring-2 focus-visible:ring-white rounded"
        aria-label="Notifications"
      >
        <i class="pi pi-bell text-lg"></i>
      </button> -->
    </div>
  </header>
  <p-tieredMenu
    #settingsMenu
    [model]="settingsMenuItems()"
    [popup]="true"
    [appendTo]="'body'"
  />
  <div class="flex min-h-0 flex-1">
    <!-- Sidebar -->
    <aside
      id="main-sidebar"
      [class.sidebar--collapsed]="isSidebarCollapsed()"
    >
      <nav class="flex-1 px-2 py-4 overflow-y-auto">
        @if (displayMenu()) {
          <div>
            <bhub-menu></bhub-menu>
          </div>
        }
      </nav>
      <div class="px-4 py-3 border-t border-surface-200">
        <ul class="space-y-1">
          <li>
            <button
              type="button"
              (click)="signOut()"
              class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-white text-left
               hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white"
              pRipple
            >
              <i class="pi pi-sign-out text-base"></i>
              <span>Sign Out</span>
            </button>
          </li>
          @if (displayMenu()) {
            <li>
              <button
                type="button"
                (click)="toggleSidebarCollapse()"
                class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-white text-left
                 hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-white"
                pRipple
              >
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-angle-double-left': !isSidebarCollapsed(),
                    'pi-angle-double-right': isSidebarCollapsed()
                  }"
                ></i>
                <span>Collapse</span>
              </button>
            </li>
          }
        </ul>
      </div>
    </aside>

    <!-- Main content area (id is skip-link target from app root; keep in sync with skip-link href) -->
    <div id="main-content" class="flex min-h-0 flex-1 flex-col">
      <!-- Page content -->
      <main class="bg-surface-100 flex min-h-0 flex-1 flex-col overflow-hidden w-full min-w-0">
        <div
          [@fadeIn]
          class="flex min-h-0 flex-1 flex-col text-surface-500 w-full min-w-0"
        >
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
</div>
